// Vendor imports
const classNames = require('classnames')
const React = require('react')
const ReactRedux = require('react-redux')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { CapsuleButton } = require('client-v2/common/components/buttons')
const seriesFeedSelectors = require('client-v2/common/containers/series-feed/selectors')
const { navigate } = require('client-v2/common/state/router/actions')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('LoggedInLandingSeriesFeedHeader')

function LoggedInLandingSeriesFeedHeader(props) {
  const routerAction = ReactRedux.useSelector(state => state.router.action)
  const defaultHeader = ReactRedux.useSelector(seriesFeedSelectors.headerElement)
  switch (routerAction) {
    case 'logged-in-landing.showFollowing':
      return tag(LoggedInLandingSeriesFeedFollowingHeader, props)
    default:
      return React.cloneElement(defaultHeader, props)
  }
}

function LoggedInLandingSeriesFeedFollowingHeader(props) {
  const dispatch = ReactRedux.useDispatch()
  const onHrefClick = React.useCallback(
    event => { dispatch(navigate(event)) },
    [ dispatch ]
  )
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block('following')
      )
    },
      tag('div', {
        className: bem.element('title')
      },
        `Recent posts `,
        tag('span', {
          className: bem.element('subtitle')
        },
          `from people you’re following`
        )
      ),
      tag(CapsuleButton, {
        className: bem.element('button'),
        href: '/follow-people',
        onClick: onHrefClick
      },
        'Discover more people to follow'
      )
    )
  )
}

module.exports = LoggedInLandingSeriesFeedHeader
